@if (form) {
  <mat-card>
    <app-card-header
      title="Agregar Excepción Horaria"
      icono="event_busy"
      [botonCerrar]="true"
      (cerrar)="dialogRef.close()"
    ></app-card-header>

    <form [formGroup]="form" (ngSubmit)="onGuardar()" autocomplete="off">
      <mat-card-content class="card-content-crear">
        <!-- Selector de Entidad (si no se recibió idEntidad) -->
        @if (mostrarSelectorEntidad) {
          <section class="inputs-group">
            <div class="full-width">
              <ng-select
                [items]="entidades"
                bindValue="id"
                bindLabel="nombre"
                formControlName="idEntidad"
                placeholder="Entidad"
                appendTo="body"
                notFoundText="Sin resultados"
                class="full-width"
              ></ng-select>
              @if (
                form.get('idEntidad')?.hasError('required') &&
                form.get('idEntidad')?.touched
              ) {
                <mat-error>La entidad es requerida</mat-error>
              }
            </div>
          </section>
        }

        <!-- Selector de Tipo de Entidad (si no se recibió tipoEntidad) -->
        @if (mostrarSelectorTipoEntidad) {
          <section class="inputs-group">
            <div class="full-width">
              <ng-select
                [items]="tiposEntidad"
                bindValue="id"
                bindLabel="nombre"
                formControlName="tipoEntidad"
                placeholder="Tipo de entidad"
                appendTo="body"
                notFoundText="Sin resultados"
                class="full-width"
              ></ng-select>
              @if (
                form.get('tipoEntidad')?.hasError('required') &&
                form.get('tipoEntidad')?.touched
              ) {
                <mat-error>El tipo de entidad es requerido</mat-error>
              }
            </div>
          </section>
        }

        <!-- Selector de Tipo de Excepción (si no se recibió tipoExcepcion) -->
        @if (mostrarSelectorTipoExcepcion) {
          <section class="inputs-group">
            <div class="full-width">
              <ng-select
                [items]="tiposExcepcion"
                bindValue="id"
                bindLabel="nombre"
                formControlName="tipoExcepcion"
                placeholder="Tipo de excepción"
                appendTo="body"
                notFoundText="Sin resultados"
                class="full-width"
              ></ng-select>
              @if (
                form.get('tipoExcepcion')?.hasError('required') &&
                form.get('tipoExcepcion')?.touched
              ) {
                <mat-error>El tipo de excepción es requerido</mat-error>
              }
            </div>
          </section>
        }

        <!-- Fechas -->
        <section class="inputs-group">
          <div class="full-width">
            <p class="etiqueta-campo">Período de excepción</p>
            <app-date-range-picker
              formControlName="range"
              [modoAvanzado]="true"
              [showModeToggle]="false"
              [maxDate]="maxFechaExcepcion"
            />
          </div>
        </section>
      </mat-card-content>

      <!-- Acciones -->
      <mat-card-actions class="actions-create">
        <button irxBoton="secundario" type="button" (click)="onCancelar()">
          Cancelar
        </button>
        <button irxBoton="principal" type="submit" [disabled]="!form.valid">
          <mat-icon>save</mat-icon>
          Guardar
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
}
